import { combineReducers } from 'redux';
import { createSelector } from 'reselect';
import payment, { actions as paymentActions, selectPaymentErrors } from './payment';
import order, {
  actions as orderActions,
  selectLocationIsLoading,
  selectLocationName,
  selectLocationPhone,
  selectOrderError,
  selectOrderIsLoading,
} from './order';
import guest, { actions as guestActions, selectGuestFatalError, selectGuestProfileLoading } from './guest';
import { connectRouter } from 'connected-react-router';

export default (history) =>
  combineReducers({
    router: connectRouter(history),
    order,
    payment,
    guest,
  });

/* v8 ignore next 5*/
export const combinedActionCreators = {
  ...paymentActions,
  ...orderActions,
  ...guestActions,
};

export const selectFatalError = createSelector(
  selectOrderError,
  selectGuestFatalError,
  (orderError, guestFatalError) => orderError || guestFatalError,
);

export const selectAppLoading = createSelector(
  selectGuestProfileLoading,
  selectOrderIsLoading,
  selectLocationIsLoading,
  (guestLoading, orderLoading, locationLoading) => guestLoading || orderLoading || locationLoading,
);

export const selectFullPaymentErrorMessages = createSelector(
  selectPaymentErrors,
  selectLocationName,
  selectLocationPhone,
  (errors, locationName, locationNumber) =>
    errors.map(
      (err) =>
        `${err} If you are still experiencing difficulties contact ${locationName} at ${locationNumber}.`,
    ),
);
